import React from 'react';
import { transferDirection } from '../../utils/transactionDirection';

// Starting In/Out choice for the dialog: the row's current flow, else its old type.
export function initialTransferDirection(t) {
  if (!t) return '';
  if (t.transaction_type === 'transfer') { const d = transferDirection(t); return d === 'unknown' ? '' : d; }
  if (t.transaction_type === 'income') return 'in';
  if (t.transaction_type === 'expense') return 'out';
  return '';
}

// Transfer edit: the other account (from/to) and which way the money went
// (In/Out, always shown so a wrong direction can be corrected). On save the row is paired with an existing opposite
// row in that account, or one is created there (backend services/transferPair).
export default function TransferPairFields({ transaction, accounts, type }) {
  if (type !== 'transfer') return null;
  const others = (accounts || []).filter((a) => Number(a.id) !== Number(transaction?.account_id));
  const paired = Boolean(transaction?.transfer_match_id);
  return (
    <div className="bg-gray-50 border rounded p-3 space-y-2" data-testid="transfer-pair-fields">
      <label className="block text-sm font-medium">Other account (transfer from / to)</label>
      <select name="counter_account_id" defaultValue="" className="w-full border rounded px-3 py-2">
        <option value="">{paired ? 'Already paired - leave as is' : 'Not set'}</option>
        {others.map((a) => <option key={a.id} value={a.id}>{a.account_name}</option>)}
      </select>
      <label className="block text-sm font-medium">Money in or out of this account</label>
      <select name="transfer_direction" data-testid="transfer-direction" defaultValue={initialTransferDirection(transaction)} required className="w-full border rounded px-3 py-2">
        <option value="">Which way did the money go?</option>
        <option value="out">Out - money left this account</option>
        <option value="in">In - money came into this account</option>
      </select>
      <p className="text-xs text-gray-600">Changing In/Out also flips the linked row in the other account. An existing matching row in the other account is linked; otherwise one is created there. Bank-connected accounts are never given a made-up row.</p>
    </div>
  );
}

// Splits the pairing fields off the form data. Returns [rowData, pairRequest|null].
export function splitPairFields(data, transactionId) {
  const { counter_account_id: counter, transfer_direction: direction, ...row } = data;
  if (direction) row.direction = direction;
  if (row.transaction_type !== 'transfer' || !counter || !transactionId) return [row, null];
  return [row, { transaction_id: transactionId, counter_account_id: counter, direction: direction || undefined }];
}
